import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=23abbeab&scoped=true"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"
import style0 from "./statement.vue?vue&type=style&index=0&id=23abbeab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abbeab",
  null
  
)

export default component.exports